import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Szoa109aRequest, Szoa109aResponse, SZOA109AService } from 'sg-api';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb122dSzoa109aService {
  /** プロダクト一覧取得結果のSubject */
  private _commonAceptSearchResult$ = new Subject<Szoa109aResponse>();

  /**
  * プロダクト一覧取得結果のobservable提供
  *
  * @readonly
  * @memberof UsedSgkb122dSzoa109aService
  */
  get valueChanges() {
    return this._commonAceptSearchResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SZOA109AService} SZOA109AService
   * @param {ApiCommonService} apiCommonService
   * @memberof UsedSgkb122dSzoa109aService
   */
  constructor(
    private sZOA109AService: SZOA109AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig
  ) { }

  /**
   *プロダクト一覧取得API呼び出し
   * @param {*} value
   * @return {*}  {Observable<Szoa109aResponse>}
   * @memberof UsedSgkb122dSzoa109aService
   */
  searchContractor(value: Szoa109aRequest): Observable<Szoa109aResponse> {
    // 検索条件を保存
    return this.sZOA109AService.c11RSZOA109APost(<Szoa109aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkErrorNoSearchData(response);
          this.apiCommonService.checkError(response);

          this._commonAceptSearchResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB,
            SgkbConstains.MESSAGE.APINAME_SZOA109A);
          return throwError(err.message);
        })
      );
  }
}
